import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from '../../../services/message.service';
import { EstadosService } from '../../../services/estados.service';
import { Subscription } from 'rxjs';
import { UtilFunctions } from '../../../general/utils-service';
import { finalize } from 'rxjs/operators';
import { ImportadoresService } from '../../../services/importadores.service';

@Component({
  selector: 'app-certificado-digital-cpf',
  templateUrl: './certificado-digital-cpf.component.html',
  styleUrls: ['./certificado-digital-cpf.component.css']
})
export class CertificadoDigitalCpfComponent extends ModalCadastroComponent implements OnInit {

  @ViewChild('modalCertDigitalCpf', { static: true }) modalCertDigitalCpf;

  constructor(
    private importadoresService: ImportadoresService,
    private estadoService: EstadosService,
    private message: MessageService,
  ) {
    super();
  }

  file: any = null;
  certificadoSelecionado = null;
  certificadoVencido = false;
  dataValidade = null;

  cadastroForm = new FormGroup({
    senha: new FormControl('', [Validators.required]),
    arquivo: new FormControl('', [Validators.required])
  });

  fileChanged(files) {
    this.file = files.length !== 0 ? files[0] : null;
    const elemento = this.cadastroForm.get('arquivo');
    elemento.setValue(this.file);
    elemento.markAsTouched();
  }

  ngOnInit() {
    this.alteraLoading(true);
    this.importadoresService.getCertificado()
      .pipe(finalize(() => this.alteraLoading(false)))
      .subscribe(res => {
        this.dataValidade = new Date(res.dataFim);
        this.estadoService.getDateFuso().toPromise()
          .then(dataServidor => {
            if (this.dataValidade < new Date(dataServidor)) {
              this.certificadoVencido = true;
              this.certificadoSelecionado = res;
            } else {
              this.certificadoVencido = false;
              this.certificadoSelecionado = res;
            }
          });
      });
  }

  show() {
    this.modalCertDigitalCpf.show();
  }

  submitForm() {
    if (this.cadastroForm.valid) {
      if (!this.file.name.toLowerCase().endsWith('.pfx') && !this.file.name.toLowerCase().endsWith('.p12')) {
        this.errors = "Informar um arquivo no formato .pfx ou .p12";
        return;
      }

      this.errors = null;
      this.alteraLoading(true);
      const form = new FormData();
      form.append('arquivo', this.file);
      form.append('senha', this.cadastroForm.get('senha').value);
      this.importadoresService.uploadCertificado(form)
        .pipe(finalize(() => { this.alteraLoading(false); }))
        .subscribe(() => {
          this.message.success('Certificado salvo com sucesso!');
          this.closed.emit(true);
        }, (error) => {
          this.errors = error.msg.errors;
        });
    }
  }
}
